import React, { useState, useMemo, useEffect } from "react";
// reactstrap components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    CardBody,
} from "reactstrap";
// core components

import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import BlockUi from 'react-block-ui';
import ReduxBlockUi from "react-block-ui/redux";
import "react-block-ui/style.css";
import { useForm } from "react-hook-form";
import MessageBox from "../../../components/ui/MessageBox";

import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/talkchinese/EditDialogRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import UnitService from "../../../services/screens/admin/unit/forms/UnitService";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import SpokenDialogField from "../unit/fields/types/SpokenDialogField";
import UIDs from "../../../UIDs";
import "antd/dist/antd.css";
import "../../../assets/scss/screens/admin/unit/unit.scss";
import Constants from "../../../config/Constants";
import { EnumHasFlag, GetPlainTextFromSentence } from "../../../utils/MarkTextHelper";
import { CharsField, ImageField } from "../unit/fields/types";
import { chars } from "voca";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";

const uid = UIDs.screens.admin.talkchinese.editdialog;

// 基本做作业时间(等待上传, 等待语音识别等)
const DURATION_BASE = 2;

// 每个字的朗读时间
const DURATION_PER_CHAR = 1;

// 每个句子的额外操作时间(点击录音, 点下一步)
const DURATION_STEP = 2;

class EditDialogScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_ASYNC]: { done: this._handleSaveAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);

    }

    componentDidMount() {
        super.componentDidMount();

        let { id } = this.localVars.navParams;
        this.props.loadScreenViewAsync(id);
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        var navParams = NavigationService.getNavParams(this.props);
        if (navParams.id !== this.localVars.navParams.id) {
            this.localVars.navParams = navParams;
            let { id } = this.localVars.navParams;
            this.props.loadScreenViewAsync(id);
        }
    }

    render() {
        const { units } = this.props.localState;
        const { index, courseName } = this.localVars.navParams;
        return this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
            ? <LoadingIndicator /> :
            <Container className="mt--7 aic-singleUnit-style" fluid>
                <ReduxBlockUi tag="div" block={[ActionTypes.LOAD_SCREEN_VIEW_ASYNC, ActionTypes.SAVE_UNIT_ASYNC]}
                    unblock={[ActionTypes.LOAD_SCREEN_VIEW_SUCCESS, ActionTypes.LOAD_SCREEN_VIEW_FAILURE, ActionTypes.SAVE_UNIT_SUCCESS, ActionTypes.SAVE_UNIT_FAILURE]}>
                    <UnitForm
                        t={this.props.t}
                        isAddDialog={this.props.isAddDialog}
                        data={{ index, courseName, units }}
                        onSave={this._handleSave}
                        onCancel={this._handleCancel} />
                </ReduxBlockUi>
            </Container>
            ;
    }

    _handleSave = vo => {
        confirmAlert({
            title: vo.nextDialog ? this.props.t("confirmToSaveAndNext") : this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        UnitForm.setBlocking(true);
                        let { courseId, id: sectionId } = this.localVars.navParams;
                        this.props.saveAsync({ courseId, sectionId, ...vo });
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancel = () => {
        const { courseId } = this.localVars.navParams;
        NavigationService.navigateToPage(this, `/admin/talkchinese/${courseId}/details`);
    }

    _handleSaveAsyncDone = (action) => {
        UnitForm.setBlocking(false);

        const { nextDialogId } = action.data;
        if (nextDialogId) {
            let { courseId, courseName, index } = this.localVars.navParams;
            NavigationService.navigateToPage(this, `/admin/talkchinese/${nextDialogId}/editdialog`,
                                             { courseId, courseName, index: index + 1 });
        }
        else {
            this._handleCancel();
        }
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
        UnitForm.setBlocking(false);
    }
}

const UnitForm = (props) => {
    const { data } = props;
    const { units, index, courseName } = data;
    const formMethods = useForm();
    let stepData = [];
    if (units.length > 0) {
        let poka1 = units[units.length - 1];
        stepData.push(poka1);
        let tempData = {};
        units.forEach(u => {
            if (u.unitType === "POKA4") {
                if (tempData.poka4) {
                    stepData.push(tempData);
                }
                tempData = { poka4: u, poka3: [] }
            } else if (u.unitType === "POKA3") {
                if (tempData.poka3) {
                    tempData.poka3.push(u);
                }
            } else {
                if (tempData.poka4) {
                    stepData.push(tempData);
                }
            }
        })
    }
    const [state_step, setstate_step] = useState(0);
    const [state_stepData, setstate_stepData] = useState(stepData);
    const [state_keywords, setstate_keywords] = useState([]);
    const [state_blocking, setstate_blocking] = useState(false);
    const [state_resourceIds, setstate_resourceIds] = useState([Helper.generateUUID()]);

    UnitForm.setBlocking = setstate_blocking;

    const findKeywordData = (datas, k) => {
        for (let i = 0; i < datas.length; ++i) {
            let data = datas[i];
            if (data.poka4 && data.poka4.data && data.poka4.data.singleUnits) {
                let u = data.poka4.data.singleUnits[0];
                let curkey = u.content.chars.join("");
                if (curkey === k) {
                    return _.clone(data);
                }
            }
        }
        return undefined;
    };

    const onBack = (formData) => {
        if (state_step === 1) {
            DialogForm.onBack(formData);
        }
        setstate_step(state_step - 1);
    }

    const onNext = (formData) => {
        if (state_step === 0) {
            DialogForm.onNext(formData, unit => {
                let keywords = [];
                let noChineseKeyword = null;
                unit.data.dialogs.forEach(({ sentences }) =>
                    sentences.forEach(sentence =>
                        sentence.words.forEach(word => {
                            if (EnumHasFlag(word.command, Constants.TEXT_MARK_TYPE.KEYWORD) && !keywords.some(w => w.chars.join("") === word.chars.join(""))) {
                                if (!noChineseKeyword) {
                                    let keywordText = word.chars.join("");
                                    if (!/^[\u4E00-\u9FA5]+$/.test(keywordText)) {
                                        noChineseKeyword = keywordText;
                                    }
                                }

                                let keyword = _.clone(word);
                                state_stepData.forEach((u) => {
                                    if (u.poka4 && u.poka4.data &&
                                        u.poka4.data.singleUnits && u.poka4.data.singleUnits[0] &&
                                        u.poka4.data.singleUnits[0].content &&
                                        u.poka4.data.singleUnits[0].content.chars &&
                                        (u.poka4.data.singleUnits[0].content.chars.join("") === word.chars.join("")))
                                    {
                                        keyword = _.clone(u.poka4.data.singleUnits[0].content);
                                    }
                                });

                                keywords.push(keyword);
                            }
                        })));

                if (noChineseKeyword) {
                    MessageBox.danger({ text: props.t("keywordNoChineseChar", {keyword: noChineseKeyword}), duration: 5000 });
                    return;
                }
                let resourceIds = _.clone(state_resourceIds);
                keywords.map(_ => resourceIds.push(Helper.generateUUID()));
                setstate_keywords(keywords);
                setstate_resourceIds(resourceIds);
                setstate_step(state_step + 1);
            });
        } else if (state_step === 1) {
            let stepData = Array.from(state_stepData);
            try {
                stepData[0] = DialogForm.buildFormData(formData);
            } catch (e) {
                MessageBox.danger({ text: e.message, duration: 5000 });
                return;
            }

            // 如果关键词有变动, 重新生成关键词数据
            for (let i = 0; i < state_keywords.length; ++i) {
                let keyword = state_keywords[i].chars.join("");
                stepData[i + 1] = findKeywordData(state_stepData, keyword);
                if (!stepData[i + 1]) {
                    stepData[i + 1] = {};
                }
            }

            // 删除多余的数据
            stepData.splice(state_keywords.length + 1);

            setstate_stepData(stepData);
            setstate_step(state_step + 1);
        } else if (state_step < state_keywords.length + 1) {
            let stepData = Array.from(state_stepData);
            KeywordForm.onNext(formData, data => {
                stepData[state_step - 1] = data;
                setstate_stepData(stepData);
                setstate_step(state_step + 1);
            });
        }
    }

    const onSaveAndNext = (formData, goNext) => {
        if (state_step === 1) {
            let unit = null;
            try {
                unit= DialogForm.buildFormData(formData);
            } catch (e) {
                MessageBox.danger({ text: e.message, duration: 5000 });
                return;
            }
            props.onSave({ data: [JSON.stringify({ ...unit, data: JSON.stringify(unit.data) })],
                           nextDialog: (goNext ? 1 : 0) });
        }

        if (state_step > 1) {
            let keywords = Array.from(state_keywords);
            let keywordCount = keywords.length;
            let keywordsChars = [];
            keywords.forEach(({ chars }) => { keywordsChars.push(...chars) });
            let charCount = new Set(keywordsChars).size;
            KeywordForm.onNext(formData, data => {
                let stepData = Array.from(state_stepData);
                stepData[state_step - 1] = data;
                let units = [];
                let poka1 = stepData.shift();
                stepData.forEach(d => {
                    const { poka3, poka4 } = d;
                    units.push(poka4, ...poka3);
                })
                units.push(poka1);
                props.onSave({ data: units.filter(u => u.dataType).map(u => JSON.stringify({ ...u, data: JSON.stringify(u.data) })), keywordCount, charCount, nextDialog: (goNext ? 1 : 0) });
            })
        }
    }

    const onSave = formData => {
        onSaveAndNext(formData, false);
    }

    const onNextDialog = formData => {
        onSaveAndNext(formData, true);
    }

    const onCancel = () => {
        props.onCancel();
    }

    const _buildForm = () => {
        if (state_step > 1) {
            return <KeywordForm
                key={state_step}
                t={props.t}
                resourceId={state_resourceIds[state_step - 1]}
                formMethods={formMethods}
                stepIndex={state_step}
                word={state_keywords[state_step - 2]}
                units={state_stepData[state_step - 1] || {}}
            />
        }

        let unit = state_stepData[0] || {};
        if (unit.data) {
            unit = { ...unit, data: unit.data.singleUnits[0] };
        }

        return <DialogForm
            resourceId={state_resourceIds[0]}
            formMethods={formMethods}
            unit={unit}
            setBlocking={setstate_blocking}
            showDetails={state_step === 1}
        />
    }


    return (
        <Row>
            <Col>
                <Card className="shadow">
                    <CardHeader className="bg-white border-1">
                        <Row className="align-items-center">
                            <Col xs="6">
                                <h3 className="mb-0">{courseName} / {props.t("dialogIndex", { index })}</h3>
                            </Col>
                            <Col className="text-right" xs="6">
                                {state_step > 0 && <Button disabled={state_blocking} size="sm" color="primary" onClick={state_step === 1 ? formMethods.handleSubmit(onBack) : onBack}>{props.t("back")}</Button>}
                                {state_step < state_keywords.length + 1 ?
                                    <Button disabled={state_blocking} size="sm" color="primary" onClick={formMethods.handleSubmit(onNext)}>{props.t("next")}</Button>
                                    :
                                 (<>
                                      <Button disabled={state_blocking} size="sm" color="primary" onClick={formMethods.handleSubmit(onSave)}>{props.t("save")}</Button>
                                      {props.isAddDialog ? null : (<Button disabled={state_blocking} size="sm" color="primary" onClick={formMethods.handleSubmit(onNextDialog)}>{props.t("nextDialog")}</Button>)}
                                  </>)
                                }<Button size="sm" color="default" onClick={onCancel}>{props.t("cancel")}</Button>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <BlockUi tag="div" blocking={state_blocking}>
                            <form id="unitForm">
                                {_buildForm()}
                            </form>
                        </BlockUi>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

const DialogForm = (props) => {
    const { resourceId, formMethods, unit, showDetails } = props;
    const [state_unit, setstate_unit] = useState(unit);

    const buildSingleUnit = (singleUnit = {}) => {
        return Object.assign(
            {
                dialogPersons: 0,
                nickNames: [],
                genders: [],
                description: {
                    sentences: []
                },
                dialogs: [
                    {
                        role: 0,
                        sentences: [{
                            chars: [],
                            syllables: [],
                            translation: {},
                            audioPath: ""
                        }]
                    }
                ],
            },
            singleUnit
        );
    };

    const buildFormData = newFormData => {
        var buildFieldsData = SpokenDialogField.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = SpokenDialogField.WrappedComponent.buildFieldsData;
        }

        let submitData = buildFieldsData(newFormData);

        let duration = DURATION_BASE;

        submitData.data.singleUnits[0].dialogs.forEach(({ sentences }) => sentences.forEach((sentence) => {
            let text = GetPlainTextFromSentence(sentence.chars.join(''));
            duration += text.length * DURATION_PER_CHAR;
            duration += DURATION_STEP;
        }));
        submitData.data.singleUnits[0].practiceRole = 100;
        if (unit.id) {
            submitData.id = unit.id;
        }

        return { ...submitData, resourceId, unitType: "POKA1", duration };
    }

    const onNext = (newFormData, callback) => {
        let submitData = {};
        try {
            submitData = buildFormData(newFormData);
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        const { id, unitType = "POKA1", ownerType, ownerId } = state_unit;
        if (submitData.charsChanged) {
            props.setBlocking(true);
            let vo = { id, unitType, ownerType, ownerId, resourceId, dataType: submitData.dataType, data: JSON.stringify(submitData.data) };
            UnitService.generateUnit(
                vo,
                (response) => {
                    props.setBlocking(false);
                    response.data = JSON.parse(response.data).singleUnits[0];
                    setstate_unit(response);
                    callback && callback(response);
                },
                (error) => {
                    props.setBlocking(false);
                    MessageBox.danger({ text: error.message, duration: 5000 });
                }
            );
        } else {
            let unit = { ...state_unit, data: submitData.data.singleUnits[0] };
            setstate_unit(unit);
            callback && callback(unit);
        }
    };

    const onBack = newFormData => {
        let submitData = {};
        try {
            submitData = buildFormData(newFormData);
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        let unit = { ...state_unit, data: submitData.data.singleUnits[0] };
        setstate_unit(unit);
    };

    DialogForm.buildFormData = buildFormData;
    DialogForm.onBack = onBack;
    DialogForm.onNext = onNext;

    const unitData = state_unit.data || unit.data;
    const { dialogPersons, nickNames, genders, description, dialogs } = buildSingleUnit(unitData || {});

    let fieldPayload = useMemo(() => ({
        dialogPersons: { name: "dialogPersons", index: 0, value: dialogPersons },
        nickNames: {name:"nickNames", index: 0, value: nickNames},
        genders: {name:"genders", index: 0, value: genders},
        description: { name: "description", index: 0, value: description },
        dialogs: { name: "dialogs", index: 0, value: dialogs },
    }), [unitData]);

    return <SpokenDialogField formMethods={formMethods} fields={fieldPayload} resourceId={resourceId} showDetails={showDetails} />;
}

const KeywordForm = (props) => {
    const { resourceId, formMethods, word, units, stepIndex } = props;
    let imagePath = "";
    if (units.poka4 && units.poka4.data) {
        imagePath = units.poka4.data.singleUnits[0].imagePath;
    }
    const keyword = word.chars.join("");
    let singleUnits = [];
    if (units.poka3 && units.poka3.length > 0) {
        units.poka3.forEach(u => singleUnits.push(...u.data.singleUnits))
    }

    const [state_singleUnits, setstate_singleUnits] = useState(singleUnits);
    const [state_initialFlag, setState_initialFlag] = useState(true);

    const buildSingleUnit = (index = 0, singleUnit = {}) => {
        const { content = {} } = singleUnit;
        return {
            content: {
                chars: { name: `chars${stepIndex}`, value: content.chars || "", label: (index + 1) + '.', index },
                syllables: { name: `syllables${stepIndex}`, value: content.syllables || "", index },
                audioPath: { name: `audioPath${stepIndex}`, value: content.audioPath || "", index },
                translation: { name: `translation${stepIndex}`, value: content.translation || "", index }
            },
        };
    }

    const init = () => {
        let tempSingleUnits = [];
        if (singleUnits.length > 0) {
            singleUnits.forEach((singleUnit, index) => tempSingleUnits.push(buildSingleUnit(index, singleUnit)));
        } else {
            tempSingleUnits.push(buildSingleUnit());
        }
        setstate_singleUnits(tempSingleUnits);
        setState_initialFlag(false);
    }

    if (state_initialFlag) {
        init();
    }

    useEffect(() => {
        init();
    }, [word, stepIndex])

    const onNext = (formData, callback) => {
        let sentenceUnits = []
        let noError = true;
        let duration = DURATION_BASE;

        formData[`chars${stepIndex}`].forEach((char, index) => {
            if (char.indexOf(keyword) === -1) {
                MessageBox.danger({ text: props.t("no keyword", {index: index + 1, keyword: keyword}), duration: 5000 });
                noError = false;
                return;
            }
            duration += char.length * DURATION_PER_CHAR;
            duration += DURATION_STEP;
            let poka3Data = {
                resourceId,
                unitType: "POKA3",
                dataType: "AiChinese.Internal.API.VO.Common.Units.POKA3UnitDataVO",
                data: {
                    singleUnits: [{
                        content: {
                            chars: [...char],
                            syllables: Helper.splitPinyinToArray(formData[`syllables${stepIndex}`][index]),
                            translation: Helper.combineTranslation(formData, `translation${stepIndex}`, index),
                            audioPath: formData[`audioPath${stepIndex}`][index],
                            words: null, //set this we can force it spilt word every time since we need support mark text.
                        },
                    }]
                },
                duration
            };

            if (units.poka3 && units.poka3[index] && units.poka3[index].id) {
                poka3Data.id = units.poka3[index].id;
            }
            sentenceUnits.push(poka3Data);
        });

        let poka4Data = {
            resourceId,
            unitType: "POKA4",
            dataType: "AiChinese.Internal.API.VO.Common.Units.POKA4UnitDataVO",
            data: {
                singleUnits: [{
                    content: {
                        ...word,
                        syllables: Helper.splitPinyinToArray(formData[`wordSyllables${stepIndex}`]),
                        translation: Helper.combineTranslation(formData, `wordTranslation${stepIndex}`),
                        audioPath: formData[`wordAudioPath${stepIndex}`],
                    },
                    imagePath: formData.imagePath[stepIndex]
                }]
            },
            duration: DURATION_BASE + word.chars.length * DURATION_PER_CHAR + DURATION_STEP,
        };

        if (units.poka4 && units.poka4.id) {
            poka4Data.id = units.poka4.id;
        }

        noError && callback && callback({
            poka3: sentenceUnits,
            poka4: poka4Data,
        });
    }

    KeywordForm.onNext = onNext;

    let imageFields = useMemo(() => ({
        imagePath: { name: "imagePath", value: imagePath, label: props.t("image", { keyword }), index: stepIndex }
    }), [word, stepIndex]);

    let poka4Fields = useMemo(() => ({
        content: {
            chars: { name: `wordChars${stepIndex}`, value: word.chars || "", label: props.t("keyword") },
            syllables: { name: `wordSyllables${stepIndex}`, value: word.syllables || "" },
            audioPath: { name: `wordAudioPath${stepIndex}`, value: word.audioPath || "" },
            translation: { name: `wordTranslation${stepIndex}`, value: word.translation || "" }
        }
    }), [word, stepIndex]);

    return <>
        <ImageField key={stepIndex} formMethods={formMethods} resourceId={resourceId} fields={{ imagePath: imageFields.imagePath }} />
        <CharsField formMethods={formMethods} resourceId={resourceId} fields={poka4Fields.content}
                    charsReadOnly={true}/>
        <div className="row" style={{marginTop: 20}}>
            <div className="col-lg-12">
                <div className="form-group practiceBlock">
                    <label className="form-control-label practiceLabel">{props.t("sentences", { keyword })}</label>
                    <div style={{ float: "right", flexDirection: "row-reverse", justifyContent: "center" }}>
                        <div style={{ float: "left", fontSize: "20px", color: "red", marginRight: "10px", cursor: "pointer" }}
                            onClick={() => {
                                let tempSingleUnits = JSON.parse(JSON.stringify(state_singleUnits));
                                let singleUnit = buildSingleUnit(state_singleUnits.length);
                                setstate_singleUnits([...tempSingleUnits, singleUnit]);
                            }}
                            title={props.t("add")}
                        >
                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div style={{ float: "left", fontSize: "20px", color: "#5e72e4", marginRight: "10px", cursor: "pointer" }}
                            onClick={() => {
                                if (state_singleUnits.length > 1) {
                                    let tempSingleUnits = JSON.parse(JSON.stringify(state_singleUnits));
                                    tempSingleUnits.pop();
                                    setstate_singleUnits(tempSingleUnits);
                                }
                            }}
                            title={props.t("delete")}
                        >
                            <i className="fa fa-minus-circle" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                {state_singleUnits && state_singleUnits.map((singleUnit, index) =>
                    <CharsField key={index} formMethods={formMethods} resourceId={resourceId} fields={singleUnit.content} />
                )}
            </div>
        </div>
    </>
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (id) => dispatch(Actions.loadScreenViewAsync(id)),
        saveAsync: vo => dispatch(Actions.saveAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditDialogScreen));
